var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkBatteryVoltage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 35,
    viewBox: "0 0 19 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48095446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_b_349_2301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6614 7.79063L13.6614 2.23963C13.6614 1.27886 12.9025 0.5 11.9664 0.5L6.55768 0.5C5.62155 0.5 4.86267 1.27886 4.86267 2.23963L4.86266 7.79063C4.86266 8.7514 5.62155 9.53026 6.55768 9.53026L11.9664 9.53026C12.9025 9.53026 13.6614 8.7514 13.6614 7.79063Z",
    fill: "url(#paint0_linear_349_2301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1614 2.23963L13.1614 7.79063C13.1614 8.48758 12.6142 9.03026 11.9664 9.03026L6.55768 9.03026C5.90986 9.03026 5.36266 8.48758 5.36266 7.79063L5.36267 2.23963C5.36267 1.54268 5.90986 1 6.55768 1L11.9664 1C12.6142 1 13.1614 1.54268 13.1614 2.23963Z",
    stroke: "url(#paint1_linear_349_2301)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_b_349_2301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57803 3.74155H15.9456C17.3689 3.74155 18.5236 5.09189 18.5236 6.75309V31.9886C18.5236 33.6531 17.3689 35.0001 15.9456 35.0001H2.57803C1.15468 35.0001 3.38133e-06 33.6531 3.38133e-06 31.9886V6.75309C3.38133e-06 5.09189 1.15468 3.74155 2.57803 3.74155Z",
    fill: "url(#paint2_linear_349_2301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.57803 4.24155H15.9456C17.0225 4.24155 18.0236 5.29214 18.0236 6.75309V31.9886C18.0236 33.4525 17.0229 34.5001 15.9456 34.5001H2.57803C1.50072 34.5001 0.500003 33.4525 0.500003 31.9886V6.75309C0.500003 5.29213 1.50105 4.24155 2.57803 4.24155Z",
    stroke: "url(#paint3_linear_349_2301)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    x: 16.2068,
    y: 13.2,
    width: 6.25172,
    height: 14.1242,
    rx: 3.12586,
    transform: "rotate(90 16.2068 13.2)",
    fill: "#33E8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 16.2068,
    y: 19.9318,
    width: 6.02017,
    height: 14.1242,
    rx: 3.01009,
    transform: "rotate(90 16.2068 19.9318)",
    fill: "#33E8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 16.2068,
    y: 26.4323,
    width: 6.25172,
    height: 14.1242,
    rx: 3.12586,
    transform: "rotate(90 16.2068 26.4323)",
    fill: "#33E8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_b_349_2301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1487 20.9271L11.1444 11.1612C11.491 10.7818 12.0774 11.1236 11.9861 11.6531L10.3257 21.2104C10.2649 21.5483 10.5008 21.8611 10.8169 21.8611L14.2751 21.8611C14.7244 21.8611 14.9453 22.4534 14.6292 22.7952L5.63344 32.561C5.2869 32.9405 4.70051 32.5987 4.79179 32.0691L6.45216 22.5118C6.51302 22.1739 6.27712 21.8611 5.96101 21.8611L2.50274 21.8611C2.05347 21.8611 1.83258 21.2688 2.1487 20.9271Z",
    fill: "url(#paint4_linear_349_2301)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51577 21.2666L2.51645 21.2658L11.4928 11.5211C11.4953 11.53 11.4974 11.5449 11.4934 11.5679C11.4934 11.568 11.4934 11.5681 11.4934 11.5682L9.83364 21.1218C9.83353 21.1224 9.83342 21.123 9.83331 21.1237C9.72778 21.7157 10.1391 22.3611 10.8169 22.3611L14.2638 22.3611C14.2661 22.3645 14.2687 22.3695 14.2713 22.3762C14.2776 22.3931 14.2791 22.411 14.2768 22.4253C14.2749 22.4374 14.2706 22.4465 14.2621 22.4557L14.2614 22.4564L5.28513 32.2012C5.28255 32.1922 5.28053 32.1774 5.28448 32.1543C5.2845 32.1542 5.28451 32.1541 5.28452 32.1541L6.94425 22.6004C6.94436 22.5998 6.94447 22.5992 6.94458 22.5986C7.05011 22.0066 6.63875 21.3611 5.96101 21.3611L2.51404 21.3611C2.51183 21.3577 2.50916 21.3528 2.50661 21.346C2.50026 21.3292 2.49877 21.3112 2.50108 21.2969C2.50302 21.2849 2.50731 21.2757 2.51577 21.2666Z",
    stroke: "url(#paint5_linear_349_2301)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_349_2301",
    x: -13.1375,
    y: -17.5,
    width: 44.7988,
    height: 45.0302,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_349_2301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_349_2301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_349_2301",
    x: -18,
    y: -14.2585,
    width: 54.5237,
    height: 67.2586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_349_2301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_349_2301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_349_2301",
    x: -16,
    y: -7,
    width: 48.7778,
    height: 57.7222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_349_2301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_349_2301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_2301",
    x1: 5.3594,
    y1: 1.00981,
    x2: 13.3673,
    y2: 8.81241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_2301",
    x1: 12.9694,
    y1: 1.13743,
    x2: 4.91505,
    y2: 8.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_349_2301",
    x1: 1.04576,
    y1: 33.2354,
    x2: 25.3686,
    y2: 18.8219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_349_2301",
    x1: 1.30756,
    y1: 6.19997,
    x2: 24.987,
    y2: 21.2037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_349_2301",
    x1: 14.0565,
    y1: 12.2264,
    x2: -2.78581,
    y2: 22.1336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_349_2301",
    x1: 13.8759,
    y1: 31.0138,
    x2: -2.52733,
    y2: 20.6969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBatteryVoltage);
export default __webpack_public_path__ + "static/media/dark_battery_voltage.a8a0f07a521390ec67cae5aa24f7c76a.svg";
export { ForwardRef as ReactComponent };